import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100 scroll-mt-[72px]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            追剧伙伴说
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-xl mx-auto">
            来自真实用户的评价，看看追剧同好们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {commentItems.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.user}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{item.user}</p>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: item.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-400 text-xs"></i>
                    ))}
                  </div>
                </div>
                <span className="text-xs text-foreground-400 flex-shrink-0">{item.date}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {commentItems.slice(3, 5).map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.user}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{item.user}</p>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: item.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-400 text-xs"></i>
                    ))}
                  </div>
                </div>
                <span className="text-xs text-foreground-400 flex-shrink-0">{item.date}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}